module.exports = __webpack_public_path__ + "static/img/whjlTitle.ac57091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whjlTitle.png
// module id = ofaM
// module chunks = 2